import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../../lib/supabase';

export default function AdminGuard({ children }) {
  const navigate = useNavigate();
  const [status, setStatus] = useState('checking'); // 'checking' | 'ok' | 'redirecting'

  useEffect(() => {
    let active = true;

    supabase.auth.getSession().then(({ data: { session } }) => {
      if (!active) return;
      if (session) setStatus('ok');
      else { setStatus('redirecting'); navigate('/admin', { replace: true }); }
    });

    const { data: subscription } = supabase.auth.onAuthStateChange((_event, session) => {
      if (!active) return;
      if (session) setStatus('ok');
      else { setStatus('redirecting'); navigate('/admin', { replace: true }); }
    });

    return () => { active = false; subscription.subscription.unsubscribe(); };
  }, [navigate]);

  if (status !== 'ok') return null;
  return children;
}
